import mixpanel from "mixpanel-browser";
import { call, put } from "redux-saga/effects";

import { TokenManagerSingleton } from "authentication/TokenManager";
import { removeFromLocalStorage } from "common/utilities/localStorage";
import { trackSaga } from "common/utilities/trackSaga";
import type { LogoutAction } from "domains/authentication/actionTypes";
import { deactivateModal } from "domains/modal/actions";
import { userSlice } from "entities/user/user.slice";
import { router } from "router/router";

export function* unauthenticatedSaga(action: LogoutAction) {
  removeFromLocalStorage("permissions");

  const logout = TokenManagerSingleton.signOut.bind(TokenManagerSingleton);
  yield call(logout);
  yield put(userSlice.actions.reset());
  yield router.navigate("/");

  yield trackSaga({ name: "Logout" });
  mixpanel.reset();

  // If the user chose to activate logout, then dismiss the inevitable "log
  // back in" modal that'll appear from any 401 responses we get.
  if (action.payload?.isUserLogout) {
    yield put(deactivateModal());
  }
}
